export default "__VITE_ASSET__DHjNK1DU__"